module.exports = __webpack_public_path__ + "static/img/Noise_X.a70fdac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/handshakes/assets/Noise_X.png
// module id = 5vhj
// module chunks = 1